import React from 'react';
import { connect } from 'react-redux';
import { getTenantState } from '../../store/selectors';
import {
  getEcapCompletionsByClass,
  getTotalEcapCompletions,
  getEcapCompletionsCsv,
} from '../../store/actions';
import { reportingCopy } from '../../copy/advisor-dashboard/advisor-dashboard-base.json';
import Loading from '../utility/Loading';
import Pagination from './Pagination';
import CSVDownloadMenu from './reporting-components/CSVDownloadMenu';
import EcapCompletionChart from './ecap-completions-components/EcapCompletionChart';
import AllEcapCompletionsChart from './ecap-completions-components/AllEcapCompletionsChart';

export class EcapCompletions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      resultPages: 1,
      currentPage: 1,
      byClassData: [],
      totalData: [],
    };

    this.getData = this.getData.bind(this);
    this.getCsv = this.getCsv.bind(this);
  }

  async componentDidMount() {
    await this.getData();
  }

  async getData(pageNumber = 1) {
    const byClassObj = await this.props.getEcapCompletionsByClass(
      this.props.tenant.id,
      pageNumber - 1
    );

    const resultPages = byClassObj.resultPages;
    const byClassData = Object.entries(byClassObj.counts);

    const totalObj = await this.props.getTotalEcapCompletions(
      this.props.tenant.id
    );
    const totalData = Object.entries(totalObj);

    this.setState({
      resultPages,
      byClassData,
      totalData,
      loading: false,
    });
  }

  async getCsv() {
    const csvData = await this.props.getEcapCompletionsCsv(
      this.props.tenant.id
    );
    return csvData;
  }

  handlePageChange = async (pageNumber) => {
    if (pageNumber !== this.state.currentPage) {
      this.setState({
        currentPage: pageNumber,
        loading: true,
      });
    }
    await this.getData(pageNumber);
  };

  legend() {
    const currentYear = new Date().getFullYear();
    const legendItems = {
      [currentYear]: reportingCopy.ecapCompletions.colorScale[0],
      [currentYear + 1]: reportingCopy.ecapCompletions.colorScale[1],
      [currentYear + 2]: reportingCopy.ecapCompletions.colorScale[2],
      [currentYear + 3]: reportingCopy.ecapCompletions.colorScale[3],
      [currentYear + 4]: reportingCopy.ecapCompletions.colorScale[4],
    };
    return (
      <div className="ecap-completions__top-section__legend-container">
        <div className="ecap-completions__top-section__legend-container-header">
          Students' Graduation Year:
        </div>
        <div className="ecap-completions__top-section__legend-items">
          {Object.entries(legendItems).map(([year, color]) => {
            return (
              <div
                className="ecap-completions__top-section__legend-item"
                key={`Class of ${year}`}
              >
                <div
                  className="ecap-completions__top-section__legend-color-square"
                  style={{
                    backgroundColor: color,
                  }}
                />
                <div className="ecap-completions__top-section__legend-label">
                  {`Class of ${year}`}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="ecap-completions">
        <div className="ecap-completions__top-section">
          <div className="ecap-completions__top-section__header">
            <div className="ecap-completions__top-section__heading">
              {reportingCopy.ecapCompletions.heading}
            </div>
            <div className="ecap-completions__top-section__meatball-menu-container">
              <CSVDownloadMenu
                csv={this.getCsv}
                filename="ecap-completions-by-class"
              />
            </div>
          </div>
          <div className="ecap-completions__top-section__content">
            <div className="ecap-completions__top-section__legend">
              {this.legend()}
            </div>
            <div className="ecap-completions__top-section__all-chart">
              {this.state.loading ? (
                <Loading height="100%" />
              ) : (
                <AllEcapCompletionsChart data={this.state.totalData[0]} />
              )}
            </div>
            <div className="ecap-completions__top-section__subheading-container">
              <div className="ecap-completions__top-section__subheading">
                {reportingCopy.ecapCompletions.subheading}
              </div>
            </div>
          </div>
        </div>
        {this.state.loading ? (
          <Loading height="700px" />
        ) : (
          <div className="ecap-completion-charts">
            {this.state.byClassData.map(([highSchool, data]) => {
              return (
                <EcapCompletionChart
                  highSchool={highSchool}
                  data={data}
                  key={highSchool}
                />
              );
            })}
          </div>
        )}
        <Pagination
          handlePageChange={this.handlePageChange}
          currentPage={this.state.currentPage}
          resultPages={this.state.resultPages}
          primaryColor={this.props.tenant.primary}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps, {
  getEcapCompletionsByClass,
  getTotalEcapCompletions,
  getEcapCompletionsCsv,
})(EcapCompletions);
